// src/views/TermsOfServiceView.tsx

// 服务条款页面

// 第三方
import React from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { ContactComp } from '../components/ContactComponent'

// 自定义
import '../css/privacy.policy.css'
import { COMMON_PAGE } from '../services/Macro'

class TermsOfServiceView extends React.Component<WithTranslation> {

    state = {
        age: COMMON_PAGE.MIN_AGE,
        corporateName: COMMON_PAGE.CORPARATE_NAME,
        stateName: COMMON_PAGE.STATE_NAME,
        lastUpdate: COMMON_PAGE.LAST_UPDATE,
    }

    render() {
        const { i18n, lan } = this.props as any
        if (lan) {
            if (lan == 'zh_CN') {
                return this.renderCn()
            }
            else {
                return this.renderEn()
            }
        }
        else {
            const lang = i18n.language
            if (lang == 'zh_CN') {
                return this.renderCn()
            }
            else {
                return this.renderEn()
            }
        }
    }

    renderEn() {
        let langEn = { lan: 'en_US' }
        return (
            <section className='white-section'>
                <div className='show-area'>
                    <h1 className="title-font">
                        <b>User Agreement</b>
                    </h1>
                    <br />
                    <div className="text-font-en">
                        <div>
                            <b>Latest update: </b>{this.state.lastUpdate}
                        </div>
                        <br />
                        <div className='h1-font-en paragraph'>
                            <b>
                                1. General
                            </b>
                        </div>
                        <div className='paragraph'>
                            The Terms constitute an agreement between the Service users (the "<b>Users</b>") and {this.state.corporateName}, defining the rights and obligations of the User and {this.state.corporateName}(including its subsidiaries and subcontractors (collectively, {this.state.corporateName})regarding the Service. Certain parts of the Service may be subject to special terms.
                        </div>
                        <div className='paragraph'>
                            The Users must read this document carefully. Once by clicking "<b>i accept</b>", downloading, installing, or otherwise accessing or using the app or the service, you acknowledge that you have read, understood, and agree to be bound by the following terms and conditions, including the privacy policy. If you are not eligible, or do not agree to these terms, then you may not use the service.
                        </div>
                        <br />
                        <div className='h1-font-en paragraph'>
                            <b>
                                2. The Eligibility of users
                            </b>
                        </div>
                        <div className='paragraph'>
                            You must be at least 18 years of age to use the Service. By agreeing to these Terms, you represent and warrant to us:
                        </div>
                        <div>
                            <b>(i)</b> that you are at least 18 years of age;
                        </div>
                        <div>
                            <b>(ii)</b> that you have not previously been suspended or removed from the Service;
                        </div>
                        <div>
                            and
                        </div>
                        <div>
                            <b>(iii)</b> that your registration and your use of the Service is in compliance with any and all applicable laws and regulations.
                        </div>
                        <br />
                        <div className='paragraph'>
                            If you are using the Service on behalf of an entity, organization, or company, you represent and warrant that you have the authority to bind such organization to these Terms and you agree to be bound by these Terms on behalf of such organization.
                        </div>
                        <br />
                        <div className='h1-font-en paragraph'>
                            <b>
                                3. About The Account and Registration
                            </b>
                        </div>
                        <div className='h2-font-en paragraph'>
                            <b>
                                3.1 The Registration Conditions
                            </b>
                        </div>
                        <div className='paragraph'>
                            To access most features of the Service, you must register for an account. When You create an account with us, You must provide Us information that is accurate, complete, and current at all times. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of Your account on Our Service.
                        </div>
                        <div className='paragraph'>
                            You are responsible for safeguarding the password that You use to access the Service and for any activities or actions under Your password, whether Your password is with Our Service or a Third-Party Social Media Service.
                        </div>
                        <div className='paragraph'>
                            You agree not to disclose Your password to any third party. You must notify Us immediately upon becoming aware of any breach of security or unauthorized use of Your account.
                        </div>
                        <div className='paragraph'>
                            You may not use as a username the name of another person or entity or that is not lawfully available for use, a name or trademark that is subject to any rights of another person or entity other than You without appropriate authorization, or a name that is otherwise offensive, vulgar or obscene.
                        </div>
                        <div className='paragraph'>
                            Users agree to meet such conditions:
                        </div>
                        <ul>
                            <li>
                                Accounts registered by bots or any other automated methods are not permitted.
                            </li>
                            <li>
                                Unless otherwise specified, each User must register only one account.
                            </li>
                            <li>
                                Unless explicitly permitted, a User account may not be shared with other persons.
                            </li>
                        </ul>
                        <br />
                        <div className='h2-font-en paragraph'>
                            <b>
                                3.2 The Termination, Suspension And Deletion of The Account
                            </b>
                        </div>
                        <div className='paragraph'>
                            Users can terminate their account and stop using the Service at any time by directly contacting us at the contact details provided in this document. If you violate any provision of these Terms, your permission to use the Service will terminate automatically.
                        </div>
                        <div className='paragraph'>
                            We reserve the right, at our sole discretion, to suspend or delete at any time and without notice, users’ accounts that it deems inappropriate, offensive or in violation of these Terms. The suspension or deletion of Users’ accounts shall not entitle Users to any claims for compensation, damages or reimbursement. The suspension or deletion of accounts due to causes attributable to the Users does not exempt the Users from paying any applicable fees or prices.
                        </div>
                        <br />
                        <div className='h1-font-en paragraph'>
                            <b>
                                4. Our Rights And Obligations
                            </b>
                        </div>
                        <div className='paragraph'>
                            <b>4.1</b> As a general rule, the Service is intended to be available 24 hours a day, every day of the week.
                        </div>
                        <div className='paragraph'>
                            <b>4.2</b> We reserve the right to change, improve and repair the Service at its sole discretion. The Service may be unavailable during maintenance outages and at other times. We also have the right to temporarily block the User's access to the Service if it is necessary for the operation of the Service.
                        </div>
                        <div className='paragraph'>
                            <b>4.3</b> We make no warranties, express or implied, with respect to the operation or functionality of the Service and does not warrant that the Service will operate without interruption or errors.
                        </div>
                        <div className='paragraph'>
                            <b>4.4</b> We reserve the right, at its sole discretion, to make free sections of the Service chargeable or to terminate the maintenance of the Service in whole or in part. We will endeavour, where reasonably possible, to inform the User in advance, through the Service or in any other manner it deems appropriate, of any changes in the Service that are material to the User, as well as of any interruptions. The changes will take effect as soon as they have been implemented. We reserve the right to terminate the agreement constituted by these Terms and to block access to the Service in such a situation, after the User has been notified of the changes.
                        </div>
                        <div className='paragraph'>
                            <b>4.5</b> The Service may not be available in all countries, and may be available only in certain languages. The service may be network-dependent. Service users bear all possible third party charges, such as mobile data charges, associated to the use of the Service.
                        </div>
                        <div className='paragraph'>
                            <b>4.6</b> We may remove from the Service material the disclosure of which in the Service We have prohibited or which, in our opinion, is against the law or good practice, inappropriate, incorrect, harmful or damaging to us, the Users or a third party. We have no obligation to notify Users of the deletion of material in advance or afterwards.
                        </div>
                        <div className='paragraph'>
                            <b>4.7</b> We reserve the right to amend the Terms. The Terms may be amended and supplemented from time to time, particularly as a result of changes in the provision or content of the Services, due to changes in legislation or the practice of officials, or due to unforeseen circumstances. We will provide notice of material changes to the e-mail address provided by the User, in the Service and/or on the Service’s website no later than thirty (30) days before the changes take effect. If a User does not accept the changes, the User has the right to discontinue the use of the Service. The User is deemed to have accepted the changes if the User uses the Service after the changes take effect.
                        </div>
                        <div className='paragraph'>
                            <b>4.8</b> We have the right to transfer the Service and its maintenance as well as related customer relationships to a company belonging to the same group as us or to a third party in the event of a sale, merger, acquisition, or transfer of substantially all of its assets or business operations, provided that the transferee agrees in writing to be bound by the same obligations which we may have under these Terms.
                        </div>
                        <div className='paragraph'>
                            <b>4.9</b> If the User has not used the Service for six (6) months, we may, at our sole discretion, annul the User's password and username. After this, the user can re-register for the Service if they wish. The User's username and password are automatically deleted when the right of use expires.
                        </div>
                        <br />
                        <div className='h1-font-en paragraph'>
                            <b>
                                5. Users' Rights And Obligations
                            </b>
                        </div>
                        <div className='paragraph'>
                            <b>5.1</b> The Service may only be used by people aged 18 and over. If the user is at least {this.state.age} years old but a minor under the laws of the user’s country, the user must review the Terms and allow their parent or legal guardian to complete the registration on the user’s behalf before using the Service is possible. The person completing the registration must be legally competent.
                        </div>
                        <div className='paragraph'>
                            <b>5.2</b> By accepting these Terms and using the Service, the user represents and warrants that they have acted in accordance with the above procedure. If the User does not accept these Terms or wishes to terminate the agreement formed by the Terms, the User must immediately stop using the Service, remove from their device any application they have downloaded for the use of the Service and not share any content or information in the Service.
                        </div>
                        <div className='paragraph'>
                            <b>5.3</b> The User's right to use the Service in accordance with the Terms is personal. The User is not entitled to assign or transfer the right to use the Service (including the password and other credentials enabling the use of the Service) to a third party. We may refuse to provide a username, cancel a granted username or prevent the User from accessing the Service in the future if the User has acted or is acting in violation of the Terms, the law or good practice. Failure to pay for the chargeable portions of the Service may also result in termination of right of use.
                        </div>
                        <div className='paragraph'>
                            <b>5.4</b> The User commits to:
                        </div>
                        <ul>
                            <li>
                                in all use of the Service, acting in accordance with the Terms and the law and good practice;
                            </li>
                            <li>
                                following the rules and instructions set elsewhere in the Service;
                            </li>
                            <li>
                                respecting the privacy of others.
                            </li>
                        </ul>
                        <br />
                        <div className='paragraph'>
                            <b>5.5</b> The User understands that we are not obligated, but have the right, to monitor how the User uses the Service, if we deem it necessary. We are not responsible for the Material submitted by users to the Service.
                        </div>
                        <div className='paragraph'>
                            <b>5.6</b> If it becomes evident that the User is violating these Terms while using the Service, or if we have reasonable grounds to believe that such violation has occurred, we reserve the right to immediately close the User Account and permanently or temporarily restrict access to the user account and/or the Service without prior notice.
                        </div>
                        <div className='paragraph'>
                            <b>5.7</b> We reserve the right, at our sole discretion, at any time to remove or to not publish notices, where the notice, its content or the User who made the notice, according to the information received by us, is suspected to involve any legal disputes whatsoever. We have no liability toward the User, even if it later were to become evident that such suspicions of legal disputes have proven to be unfounded.
                        </div>
                        <div className='paragraph'>
                            <b>5.8</b> In addition, termination of the right to use the Service does not relieve the User of payments for the services or performances whose basis has arisen before the termination of the right of use. Upon termination of the Agreement due to the User's breach of contract, we have the right not to grant the User access to the Service.
                        </div>
                        <div className='paragraph'>
                            <b>5.9</b> If you provide feedback to us regarding the Service, you acknowledge that the Feedback is not confidential and you authorize us to use that Feedback without restriction and without payment to you. Accordingly, you hereby grant to us a nonexclusive, royalty-free, fully-paid, perpetual, irrevocable, transferable, and fully sublicensable right to use the Feedback in any manner and for any purpose.
                        </div>
                        <div className='paragraph'>
                            <b>5.10</b> You agree that you will be responsible for your use of the Service, and you agree to defend, indemnify, and hold harmless us and our officers, directors, employees, consultants, affiliates, subsidiaries and agents from and against any and all claims, liabilities, damages, losses, and expenses, including reasonable attorneys' fees and costs, arising out of or in any way connected with
                        </div>
                        <div>
                            <b>(i)</b> your access to, use of, or alleged use of the Service;
                        </div>
                        <div>
                            <b>(ii)</b> your violation of these Terms or any representation, warranty, or agreements referenced herein, or any applicable law or regulation;
                        </div>
                        <div>
                            <b>(iii)</b> your violation of any third-party right, including without limitation any intellectual property right, publicity, confidentiality, property or privacy right; or
                        </div>
                        <div>
                            <b>(iv)</b> any disputes or issues between you and any third party. We reserve the right, at our own expense, to assume the exclusive defense and control of any matter otherwise subject to indemnification by you (and without limiting your indemnification obligations with respect to such matter), and in such case, you agree to cooperate with our defense of such claim.
                        </div>
                        <br />
                        <div className='h1-font-en paragraph'>
                            <b>
                                6. Intellectual Property
                            </b>
                        </div>
                        <div className='paragraph'>
                            The Service, its features and content are owned by us or our licensors, and are protected by laws. We shall retain title, ownership rights and all intellectual property rights in and to the Service features and any and all software, documentation, intellectual property or other proprietary information or materials used or delivered in connection with the Service. Unless otherwise stated, you may print or download information from the Service for personal, non-commercial use only, provided:
                        </div>
                        <ul>
                            <li>
                                you do not modify any documents or their related graphics in any way;
                            </li>
                            <li>
                                you do not use any illustrations, photographs, video or audio sequences or any graphics separately from any accompanying text;
                            </li>
                            <li>
                                and you include an acknowledgement alongside the copied material noting the source of the material and include the statement "<b>the materials are protected by copyright law</b>".
                            </li>
                        </ul>
                        <br />
                        <div className='paragraph'>
                            Reprinting or otherwise reproducing any document in whole or in part is prohibited, unless prior written consent is obtained from the copyright owner. Nothing in these Terms shall be interpreted to mean that you have rights to repackage, sell, resell, post on blogs or on any other platform, republish, reproduce, link or frame or store any material without our permission.
                        </div>
                        <div className='paragraph'>
                            You acknowledge and agree that we shall have the right in its sole discretion to refuse to accept or to remove any content provided by you in connection with The Service features if doing so would violate these Terms or would be otherwise objectionable in our sole and absolute discretion.
                        </div>
                        <div className='paragraph'>
                            These Terms do not grant you any right, title, license or interest in or to any software or documentation, or in any related patents, copyrights, trademarks, trade secrets or other intellectual property of any kind, of us, or our affiliates. You shall not acquire any rights of any kind in or to any trademark, service mark, trade name, logo or product or service designation (whether or not registered) under which we, and our affiliates market their products or services and you shall not use the same for any reason.
                        </div>
                        <div className='paragraph'>
                            All copyrightable text, graphics, design, selection and arrangement of information in this platform are copyrighted by us unless otherwise noted. You may not edit or alter any material on the Service.
                        </div>
                        <div className='paragraph'>
                            You acknowledge that we may terminate or suspend your right to use the Service if you breach, or if we have reasonable grounds to suspect that you have breached the provisions of these Terms.
                        </div>
                        <br />
                        <div className='h1-font-en paragraph'>
                            <b>
                                7. The Limitation and Exemption of Liability to Us
                            </b>
                        </div>
                        <div className='paragraph'>
                            NOTWITHSTANDING ANY DAMAGES THAT YOU MIGHT INCUR, THE ENTIRE LIABILITY OF US , OUR AFFILIATES  AND ANY OF ITS SUPPLIERS UNDER  ANY PROVISION OF THESE TERMS AND YOUR EXCLUSIVE REMEDY  FOR ALL OF THE FOREGOING SHALL BE LIMITED TO THE AMOUNT ACTUALLY PAID BY YOU THROUGH THE SERVICE OR 100 USD  IF YOU HAVEN'T PURCHASED ANYTHING THROUGH THE SERVICE. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL WE, OUR AFFILIATES OR ITS SUPPLIERS BE LIABLE FOR ANY SPECIAL, INCIDENTAL, INDIRECT, OR CONSEQUENTIAL DAMAGES WHATSOEVER (INCLUDING, BUT NOT LIMITED TO, DAMAGES FOR LOSS OF PROFITS, LOSS OF DATA OR OTHER INFORMATION, FOR BUSINESS INTERRUPTION, FOR PERSONAL INJURY, LOSS OF PRIVACY ARISING OUT OF OR IN ANY WAY RELATED TO THE USE OF OR INABILITY TO USE THE SERVICE, THIRD-PARTY SOFTWARE AND/OR THIRD-PARTY HARDWARE USED WITH THE SERVICE, OR OTHERWISE IN CONNECTION WITH ANY PROVISION OF THIS TERMS), EVEN IF WE OR ANY SUPPLIER HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES AND EVEN IF THE REMEDY FAILS OF ITS ESSENTIAL PURPOSE. SOME COUNTRIES DO NOT ALLOW THE EXCLUSION OF IMPLIED WARRANTIES OR LIMITATION OF LIABILITY FOR INCIDENTAL OR CONSEQUENTIAL DAMAGES, WHICH MEANS THAT SOME OF THE ABOVE LIMITATIONS MAY NOT APPLY. IN THESE COUNTRIES, EACH PARTY'S LIABILITY WILL BE LIMITED TO THE GREATEST EXTENT PERMITTED BY LAW.
                        </div>
                        <br />
                        <div className='h1-font-en paragraph'>
                            <b>
                                8. Privacy Policy
                            </b>
                        </div>
                        <div className='paragraph'>
                            Please read our Privacy Policy carefully for information relating to our collection, use, storage and disclosure of your personal information. Our Privacy Policy is hereby incorporated by reference into, and made a part of, these Terms.
                        </div>
                        <br />
                        <div className='h1-font-en paragraph'>
                            <b>
                                9. The Third-party Service
                            </b>
                        </div>
                        <div className='paragraph'>
                            We may provide tools through the Service that enable you to export information to third party services, including through features that allow you to link your account with an account on the third party service. By using one of these tools, you agree that we may transfer that information to the applicable third-party service. Third party services are not under our control, and we are not responsible for any third party service’s use of your exported information. The Service may also contain links to third party websites. Linked websites are not under our control, and we are not responsible for their content.
                        </div>
                        <br />
                        <div className='h1-font-en paragraph'>
                            <b>
                                10.The Modification of Terms
                            </b>
                        </div>
                        <div className='paragraph'>
                            We reserve the right to amend or otherwise modify these Terms at any time. In such cases, we will appropriately inform the User of these changes.
                        </div>
                        <div className='paragraph'>
                            Such changes will only affect the relationship with the User from the date communicated to Users onwards. The continued use of the Service will signify the User's acceptance of the revised Terms. If Users do not wish to be bound by the changes, they must stop using the Service and may terminate the Agreement. The applicable previous version will govern the relationship prior to the User's acceptance. The User can obtain any previous version from us. If legally required, we will notify Users in advance of when the modified Terms will take effect.
                        </div>
                        <br />
                        <div className='h1-font-en paragraph'>
                            <b>
                                11. Governing Law
                            </b>
                        </div>
                        <div className='paragraph'>
                            These Terms shall be governed by the laws of {this.state.stateName} without regard to conflict of law principles.
                        </div>
                        <br />
                        <div className='h1-font-en paragraph'>
                            <b>
                                12. Dispute Resolution
                            </b>
                        </div>
                        <div className='paragraph'>
                            If You have any concern or dispute about the Service, You agree to first try to resolve the dispute informally by contacting us. To the extent that any lawsuit or court proceeding is permitted hereunder, you and us agree to submit to the courts located within {this.state.stateName} for the purpose of litigating all such disputes.
                        </div>
                        <br />
                        <div className='h1-font-en paragraph'>
                            <b>
                                13. Contact Us
                            </b>
                        </div>
                        <div className='paragraph'>
                            If you have any questions about the above terms, You can contact us by the following ways:
                        </div>
                        <ContactComp {...langEn} />
                        <br />
                    </div>
                </div>
            </section >
        )
    }

    renderCn() {
        let langZh = { lan: 'zh_CN' }
        return (
            <section className='white-section'>
                <div className='show-area'>
                    <h1 className="align-center title-font">
                        用户协议
                    </h1>
                    <br />
                    <div className="text-font">
                        <div>
                            <b>最新更新：</b>{this.state.lastUpdate}
                        </div>
                        <br />
                        <div className='h1-font'>
                            <b>
                                1. 总则
                            </b>
                        </div>
                        <br />
                        <div>
                            本条款构成了服务用户（"<b>用户</b>"）与{this.state.corporateName}（包括其子公司和分包商，统称"<b>{this.state.corporateName}</b>"）之间关于服务的权利和义务的协议。服务的某些部分可能受特殊条款的约束。
                        </div>
                        <br />
                        <div>
                            用户必须仔细阅读本文件。通过点击"<b>我接受</b>"、下载、安装或以其他方式访问或使用应用程序或服务，即表示您确认已阅读、理解并同意受以下条款和条件（包括隐私政策）的约束。如果您不符合资格或不同意这些条款，则不得使用本服务。
                        </div>
                        <br />
                        <div className='h1-font'>
                            <b>
                                2. 用户资格
                            </b>
                        </div>
                        <br />
                        <div>
                            您必须年满{this.state.age}岁才能使用本服务。同意这些条款即表示您向我们声明并保证：
                        </div>
                        <br />
                        <div>
                            (i) 您已年满{this.state.age}岁；
                        </div>
                        <div>
                            (ii) 您此前未被暂停或移除服务使用权；
                        </div>
                        <div>
                            (iii) 您的注册和使用服务符合所有适用的法律法规。如果您代表某实体、组织或公司使用本服务，您声明并保证您有权使该组织受这些条款约束。
                        </div>
                        <br />
                        <div className='h1-font'>
                            <b>
                                3. 关于账户和注册
                            </b>
                        </div>
                        <br />
                        <div>
                            <b>
                                3.1 注册条件
                            </b>
                        </div>
                        <br />
                        <div>
                            要访问服务的大多数功能，您必须注册账户。创建账户时，您必须始终提供准确、完整和最新的信息。未能做到这一点将构成违反条款，可能导致您的账户被立即终止。
                        </div>
                        <br />
                        <div>
                            您有责任保护用于访问服务的密码，并对使用您密码进行的任何活动或行为负责。
                        </div>
                        <br />
                        <div>
                            您同意不向任何第三方披露您的密码。发现任何安全漏洞或未经授权使用您账户的情况时，您必须立即通知我们。
                        </div>
                        <br />
                        <div>
                            您不得使用他人或实体的名称，或未经适当授权的受他人或实体权利保护的名称或商标，或其他具有攻击性、粗俗或淫秽的名称作为用户名。
                        </div>
                        <br />
                        <div>
                            用户同意满足以下条件：
                        </div>
                        <br />
                        <ul>
                            <li>
                                不允许使用机器人或任何其他自动方法注册账户
                            </li>
                            <li>
                                除非另有说明，每个用户只能注册一个账户
                            </li>
                            <li>
                                除非明确允许，用户账户不得与他人共享
                            </li>
                        </ul>
                        <br />
                        <div>
                            <b>
                                3.2 账户的终止、暂停和删除
                            </b>
                        </div>
                        <br />
                        <div>
                            用户可以随时通过直接联系我们终止其账户并停止使用服务。如果您违反这些条款的任何规定，您使用服务的权限将自动终止。
                        </div>
                        <br />
                        <div>
                            我们保留自行决定随时暂停或删除我们认为不当、冒犯性或违反这些条款的用户账户的权利，无需事先通知。用户账户的暂停或删除不会使用户有权要求赔偿、损害赔偿或退款。
                        </div>
                        <br />
                        <div className='h1-font'>
                            <b>
                                4. 我们的权利和义务
                            </b>
                        </div>
                        <br />
                        <ul>
                        <li>
                            原则上，服务旨在每周7天，每天24小时提供
                        </li>
                        <li>
                            我们保留自行决定更改、改进和维修服务的权利
                        </li>
                        <li>
                            我们对服务的运行或功能不作任何明示或暗示的保证
                        </li>
                        <li>
                            我们保留将免费服务部分改为收费或终止全部或部分服务维护的权利
                        </li>
                        <li>
                            服务可能并非在所有国家都可用，且可能仅提供特定语言版本
                        </li>
                        <li>
                            我们可以删除服务中我们禁止披露或认为违法或违反良好惯例的内容
                        </li>
                        <li>
                            我们保留修改条款的权利
                        </li>
                        </ul>
                        <br />
                        <div className='h1-font'>
                            <b>
                                5. 用户的权利和义务
                            </b>
                        </div>
                        <br />
                        <ul>
                        <li>
                            服务仅供18岁及以上人士使用
                        </li>
                        <li>
                            用户必须遵守条款、法律和良好惯例
                        </li>
                        <li>
                            用户的使用权是个人的，不得转让
                        </li>
                        <li>
                            用户同意对其使用服务承担责任
                        </li>
                        <li>
                            违反条款可能导致账户被关闭或访问受限
                        </li>
                        </ul>
                        <br />
                        <div className='h1-font'>
                            <b>
                                6. 知识产权
                            </b>
                        </div>
                        <br />
                        <div>
                            服务及其功能和内容归我们或我们的许可方所有，受法律保护。用户仅可在特定条件下个人非商业使用。
                        </div>
                        <br />
                        <div className='h1-font'>
                            <b>
                                7. 责任限制
                            </b>
                        </div>
                        <br />
                        <div>
                            我们的责任限于用户通过服务实际支付的金额或100美元（如果未购买任何内容）。
                        </div>
                        <br />
                        <div className='h1-font'>
                            <b>
                                8. 隐私政策
                            </b>
                        </div>
                        <br />
                        <div>
                            请仔细阅读我们的隐私政策，了解我们如何收集、使用、存储和披露您的个人信息。
                        </div>
                        <br />
                        <div className='h1-font'>
                            <b>
                                9. 第三方服务
                            </b>
                        </div>
                        <br />
                        <div>
                            我们不对第三方服务的使用负责。
                        </div>
                        <br />
                        <div className='h1-font'>
                            <b>
                                10. 条款修改
                            </b>
                        </div>
                        <br />
                        <div>
                            我们保留随时修改这些条款的权利，并会适当通知用户。
                        </div>
                        <br />
                        <div className='h1-font'>
                            <b>
                                11. 适用法律
                            </b>
                        </div>
                        <br />
                        <div>
                            这些条款受 {this.state.stateName} 法律管辖。
                        </div>
                        <br />
                        <div className='h1-font'>
                            <b>
                                12. 争议解决
                            </b>
                        </div>
                        <br />
                        <div>
                            如有争议，您同意首先尝试通过联系我们进行非正式解决。
                        </div>
                        <br />
                        <div className='h1-font'>
                            <b>
                                13. 联系我们
                            </b>
                        </div>
                        <br />
                        <div>
                            如对以上条款有任何问题，可通过以下方式联系我们：
                        </div>
                        <br />
                        <ContactComp {...langZh} />
                        <br />
                    </div>
                </div>
            </section >
        )
    }

}
export const TermsOfServicePage = withTranslation()(TermsOfServiceView)